import React from 'react';

import { StickyFooter as StickyFooterBare } from '@interlayer/js/app/components/main/StickyFooter/StickyFooter';

import { componentService } from '@core/js/services/component.service';

import { TStickyFooterProps } from '@interlayer/js/app/components/main/StickyFooter/types';

export const StickyFooter: React.FC<TStickyFooterProps> = ({ ...config }) => (
    <StickyFooterBare
        {...config}
        withrecently={false}
    />
);

componentService.registerWebContentComponents({ StickyFooter });
